<template v-else>
    <v-container class="fill-height">
        <v-responsive class="align-center text-center fill-height">
            <v-card outlined max-width="560" class="mx-auto pt-3 pb-5 px-3">
                <v-card-title class="text-h4 justify-center">{{ $t("title") }}</v-card-title>
                <v-divider></v-divider>
                <v-card-text v-if="error" class="pb-0">
                    <v-alert :icon=false dense outlined dismissible type="error">{{ $t("unableToSignIn") }}: {{ errorMessage
                    }}</v-alert>
                </v-card-text>
                <v-card-text class="pb-3">
                    <p class="text-center">{{ $t("subtitle") }}</p>
                    <v-form ref="form" @submit.prevent="signIn" v-model="valid" validate-on="submit">
                        <v-text-field id="username" type="email" v-model="username" :label="$t('email')" :rules="emailRules"
                            hide-details outlined autofocus class="mb-2"></v-text-field>
                        <v-text-field id="password" type="password" v-model="password" :label="$t('password')"
                            :rules="passwordRules" hide-details outlined class="mb-2"></v-text-field>
                    </v-form>
                    <div class="d-flex justify-center mt-1 mb-1">
                        <router-link to="/reset-password">{{ $t('forgotPassword') }}</router-link>
                    </div>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions class="mt-3">
                    <v-btn name="submit" color="primary" large @click="submit()" block>{{ $t("signIn") }}</v-btn>
                </v-card-actions>
                <v-card-actions class="mt-3">
                    <v-btn name="submit" color="warning" large @click="signIn()" block>{{ $t("SIGN_IN_WITH_GOOGLE") }}</v-btn>
                </v-card-actions>
                <v-card-actions class="mt-3">
                    <v-btn name="submit" color="warning" large @click="signUp()" block>{{ $t("SIGN_UP") }}</v-btn>
                </v-card-actions>
            </v-card>
            <p class="text-center mt-5">
                
                <a :href="termsAndConditions" target="_blank" class="text-decoration-none">{{ $t('terms') }}</a>
            </p>
            <v-overlay v-show=showOverlay :color="this.$vuetify.theme.dark ? '#000000' : '#FFFFFF'" opacity=1 z-index=500>
                <v-img v-if="this.$vuetify.theme.dark" height="50" width="300" :src="require('@/assets/logo-dark.png')"></v-img>
                <v-img v-else height="50" width="300" :src="require('@/assets/logo-light.png')"></v-img>
                <v-sheet color="transparent" class="ml-10 mr-10 mt-5">
                    <v-progress-linear indeterminate rounded></v-progress-linear>
                </v-sheet>
            </v-overlay>
        </v-responsive>
    </v-container>
</template>
<script>
export default {
    name: "PasswordAuthentication",
    data() {
        return {
            valid: false,
            username: null,
            password: null,
            showOverlay: false,
            error: null,
            errorMessage: null,
            emailRules: [],
            passwordRules: [],
        };
    },
    computed: {
        termsAndConditions() {
            return process.env.VUE_APP_TERMS_CONDITIONS;
        },
    },
    methods: {
        submit() {
            this.emailRules = [
                value => {
                    if (value) return true
                    return this.$t('emailRequired');
                },
                value => {
                    if (/.+@.+\..+/.test(value)) return true
                    return this.$t('emailError');
                },
            ],
            this.passwordRules = [
                value => {
                    if (value) return true
                    return this.$t('passwordRequired');
                }
            ],

            this.$nextTick(() => {
                if (this.$refs.form.validate()) {
                    this.showOverlay = true;
                    this.$store.dispatch('signIn', {
                        username: this.username,
                        password: this.password
                    }).then(() => {
                        this.sleep(1).then(() => {
                            if (this.$route.query.redirect != null) {
                                this.$router.push(this.$route.query.redirect);
                                this.$route.query.redirect = null;
                            } else {
                                this.$router.push("/home");
                            }
                        }).catch((error) => {
                            console.log(error);
                        });
                    }).catch((error) => {
                        this.showOverlay = false;
                        if (403 === error.response.status) {
                            this.$emit('mfa-required', { username: this.username, session: error.response.data.session });
                        } else {
                            this.error = true;
                            this.errorMessage = error.response.data.errorDescription;
                        }
                    });
                }
            });
        },
        sleep(ms) {
            return new Promise(resolve => setTimeout(resolve, ms));
        },
        signIn() {
            window.location.href = process.env.VUE_APP_LOGIN_URL + "/login?response_type=code&client_id=" + process.env.VUE_APP_CLIENT_ID + "&redirect_uri=" + process.env.VUE_APP_SIGN_IN_CALLBACK;
        },
        signUp() {
            window.location.href = process.env.VUE_APP_LOGIN_URL + "/signup?response_type=code&client_id=" + process.env.VUE_APP_CLIENT_ID + "&redirect_uri=" + process.env.VUE_APP_SIGN_IN_CALLBACK;
        }
    },
};
</script>
<i18n>
{
  "en": {
    "title" : "Welcome Back",
    "subtitle" : "Sign into your account using your email and password",
    "email" : "Email",
    "password" : "Password",
    "emailRequired" : "Email is requred.",
    "passwordRequired" : "Password is requred.",
    "emailError" : "Eamil must be valid.",
    "signIn" : "Sign In",
    "forgotPassword" : "Forgot Password?",
    "unableToSignIn" : "Something went wrong and we are unable to sign you in:",
    "terms" : "Terms",
    "SIGN_IN_WITH_GOOGLE" : "Sign in with Google",
    "SIGN_UP" : "Sign up",
    "message" : "Authorizing..."
  }
}
</i18n>